<template>
    <div id="finish">
        <section class="layout">
            <div class="header">
                <h1 class="text-sm text-center text-white mb-2">
                    { Quiz title }
                </h1>
                <h2 class="text-center text-white">{{ $route.params.type == 'quiz' ? 'Quiz' : 'Poll' }} Done!</h2>
            </div>
            <div class="content has-bottom-fade">

                <!-- Begin Quiz Result -->
                <div v-if="$route.params.type == 'quiz'">
                    <h3 class="text-center text-white">Score summary:</h3>
                    <div class="">
                        <ol class="text-center">
                            <li :key="user.id" class="text-white font-bold text-xl" v-for="user in users">{{ user.name }} ({{ user.score }})</li>
                        </ol>
                    </div>
                </div>
                <!-- End Quiz Result -->

                <!-- Begin Poll Result -->
                <div v-if="$route.params.type == 'poll'">
                    <div :key="question.id" v-for="(question, index) in questions">
                        <h4 class="mt-0 text-white">{{ question.title }} </h4>
                        <div :key="pollAnswer.id" v-for="pollAnswer in question.answers" class="block w-full">
                            <div class="flex mb-2">
                                <div style="white-space:nowrap; text-overflow: ellipsis;" class="bg-white p-2 overflow-hidden" :style="{'width': pollAnswer.percent + '%'}">
                                    <span class="text-black font-bold text-sm" v-if="pollAnswer.percent > 50">{{ pollAnswer.percent }}% {{
                                        pollAnswer.title }}</span>
                                </div>
                                <div :style="{'width': (100 - pollAnswer.percent) + '%', 'white-space': 'nowrap', 'text-overflow': 'ellipsis'}"
                                    v-if="pollAnswer.percent <= 50"
                                    class="text-white text-sm font-bold outer-result p-2 overflow-hidden">{{ pollAnswer.percent }}% {{ pollAnswer.title }}</div>
                            </div>
                        </div>

                        <div v-if="questions.length > 1 && (index + 1) != questions.length "
                            class="border-b border-t-0 border-l-0 border-r-0 pt-4 border-solid border-white mb-2"></div>
                    </div>
                </div>
                <!-- End Poll Result -->

                <div class="h-8"></div>

            </div>
            <div class="footer">
                <div class="flex items-center justify-center">
                    <button class="btn">Play again</button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {

    data: function() {
        return {
            questions: [
                {
                    title: 'Poll 1 result',
                    type: 'poll',
                    answers: [{
                            title: 'This is long answer should supported',
                            image: '',
                            percent: 70
                        },
                        {
                            title: 'Choice B',
                            image: '',
                            percent: 10
                        },
                        {
                            title: 'This is long answer should supported',
                            image: '',
                            percent: 20
                        }
                    ]
                },
                {
                    title: 'Poll 2 result',
                    type: 'poll',
                    answers: [{
                            title: 'This is long answer should supported',
                            image: '',
                            percent: 20
                        },
                        {
                            title: 'Choice B',
                            image: '',
                            percent: 30
                        },
                        {
                            title: 'This is long answer should supported',
                            image: '',
                            percent: 51
                        }
                    ]
                }
            ],
            users: [
                {
                    name: 'Lamp',
                    score: 10
                },
                {
                    name: 'Vichit',
                    score: 10
                },
                {
                    name: 'John',
                    score: 10
                },
                {
                    name: 'Adam',
                    score: 10
                },
                {
                    name: 'Somchai',
                    score: 10
                },
                {
                    name: 'Somjit',
                    score: 10
                },
                {
                    name: 'Siri',
                    score: 10
                },
                {
                    name: 'Lio',
                    score: 10
                },
                {
                    name: 'Ching',
                    score: 10
                },
            ]
        }
    }
}
</script>

